import RGBColor from '../classes/rgb-color';

const kb = (a, alpha, c, b) => {
  a = (a % 360) / 60;
  let r = b;
  let g = b;
  const h = c * (1 - Math.abs((a % 2) - 1));

  // eslint-disable-next-line default-case
  switch (Math.floor(a)) {
    case 0:
      r += c;
      g += h;
      break;
    case 1:
      r += h;
      g += c;
      break;
    case 2:
      g += c;
      b += h;
      break;
    case 3:
      g += h;
      b += c;
      break;
    case 4:
      r += h;
      b += c;
      break;
    case 5:
      r += c;
      b += h;
  }

  return new RGBColor(r, g, b, alpha);
};

export default kb;
